// code from https://github.com/Modernizr/Modernizr/blob/master/feature-detects/storage/localstorage.js
export const checkIfLocalStorageIsSupportedByBrowser = () => {
    const mod = "modernizr"
    try {
        window.localStorage.setItem(mod, mod)
        window.localStorage.removeItem(mod)
        return true
    } catch (_e) {
        return false
    }
}
